<template>
    <div class="modal modal-lg" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{ data.alarmCheckId ? 'Redigera kontroll' : 'Lägg till kontroll'}}</h4>

                    <button type="button" class="btn-close" @click="$emit('close')"></button>
                </div>
                <div class="modal-body">
                    <!-- Type and inteval -->
                    <div class="mt-3 mb-3 row">
                        <div class="col-6">
                            <div class="form-control-group">
                                <input type="checkbox" id="enabledCheck" class="form-check-input" v-model="data.isEnabled" />
                                <label for="enabledCheck" class="form-check-label">&nbsp;Aktiv
                                    <info-icon title="Bocka ur om kontrollen skall inaktiveras tillfälligt utan att tas bort." />
                                </label>
                            </div>
                            <div class="form-control-group mt-3">
                                <label for="checkSelect" class="form-label">Typ av kontroll</label>
                                <select id="checkSelect" class="form-select" v-model="data.checkType" @change="updateDeviceTypes(true)">
                                    <option value="usage">Förbrukning inom gränser</option>
                                    <option value="average">Medelvärde inom gränser</option>
                                    <option value="value">Värde inom gränser</option>
                                    <option value="status">Statusflaggor</option>
                                    <option value="collection">Insamling</option>
                                </select>
                                <div class="text-danger" v-show="data.errors.checkType">{{ data.errors.checkType }}</div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div>&nbsp;</div>
                            <div class="alert alert-secondary" v-show="data.checkType">
                                <div v-show="data.checkType === 'usage'">Kontrollera att förbrukningar ligger inom satta gränser.</div>
                                <div v-show="data.checkType === 'average'">Kontrollera att ett medelvärde för ett intervall ligger inom satta gränser.</div>
                                <div v-show="data.checkType === 'value'">Kontrollera att ett momentant värde ligger inom satta gränser.</div>
                                <div v-show="data.checkType === 'status'">Kontrollera om fel- eller statusflaggor är satta.</div>
                                <div v-show="data.checkType === 'collection'">Kontrollera om mätvärden kommer in.</div>
                            </div>
                        </div>
                    </div>
                    <!-- Devices -->
                    <div class="mt-3 mb-3 row">
                        <div class="col-6">
                            <label for="mpTypeSelect" class="form-label">Mätpunkt / Mätartyp</label>
                            <select id="mpTypeSelect" class="form-select" v-model="data.settings.mpType" @change="updateFields(true)">
                                <option v-for="mp of data.form.mpSelection" :key="mp.value" :value="mp.value">{{ mp.label }}</option>
                            </select>
                            <div class="text-danger" v-show="data.errors.mpType">{{ data.errors.mpType }}</div>
                        </div>
                        <div class="col-6" v-show="data.checkType !== 'collection'">
                            <label for="fieldSelect" class="form-label">Fält</label>
                            <select v-if="data.checkType !== 'status'" id="fieldSelect" class="form-select" v-model="data.settings.field">
                                <option v-for="f of data.form.fields" :key="f" :value="f">{{ seriesHelpers.getFieldLabel(f) }}</option>
                            </select>
                            <select v-else id="fieldSelect" class="form-select" v-model="data.settings.field">
                                <option value="status">Status</option>
                                <option value="error">Felflaggor</option>
                            </select>
                            <div class="text-danger" v-show="data.errors.field">{{ data.errors.field }}</div>
                        </div>
                    </div>
                    <!-- Control interval -->
                    <div v-show ="data.checkType === 'usage' || data.checkType === 'average' || data.checkType === 'collection' ">
                        <div class="row mb-3">
                            <label for="intervalCountInput" class="form-label">{{ data.checkType === 'collection' ? 'Kontrollintervall' : 'Period' }}
                                <info-icon title="Notera att detta är kalendertid, så om man väljer t ex månad så gäller kontrollen för kalendermånad." />
                            </label>
                            <div v-show="data.checkType === 'collection'" class="col-2">
                                <input id="intervalCountInput" type="number" min="1" class="form-control" v-model="data.intervalCount" />
                                <div class="text-danger" v-show="data.errors.intervalCount">{{ data.errors.intervalCount }}</div>
                            </div>
                            <div class="col-3">
                                <select id="intervalTypeSelect" class="form-select" v-model="data.intervalType">
                                    <option value="hour">{{ data.checkType != 'collection' || data.intervalCount == 1 ? 'timme' : 'timmar' }}</option>
                                    <option value="day">{{ data.checkType != 'collection' || data.intervalCount == 1 ? 'dag' : 'dagar' }}</option>
                                    <option value="week">{{ data.checkType != 'collection' || data.intervalCount == 1 ? 'vecka' : 'veckor' }}</option>
                                    <option value="month">{{ data.checkType != 'collection' || data.intervalCount == 1 ? 'månad' : 'månader' }}</option>
                                    <option value="year">år</option>
                                </select>
                                <div class="text-danger" v-show="data.errors.intervalType">{{ data.errors.intervalType }}</div>
                            </div>
                        </div>
                    </div>
                    <!-- Limits -->
                    <div class="mb-3" v-show="data.checkType === 'usage' || data.checkType === 'average' || data.checkType === 'value'">
                        <div class="mb-3">
                            <div>Är det samma gränsvärden hela året?</div>
                            <input type="radio" id="alwaysSameRadio" class="form-check-input" v-model="data.settings.sameAllMonths" value="true" name="all-months" />
                            <label for="alwaysSameRadio" class="form-label">&nbsp;Ja</label>
                            <input type="radio" id="differentRadio" class="ms-3 form-check-input" v-model="data.settings.sameAllMonths" value="false" name="all-months" />
                            <label for="differentRadio" class="form-label">&nbsp;Nej</label>
                        </div>
                        <div class="row" v-if="data.settings.sameAllMonths === 'true'">
                            <div class="col-4">
                                <label for="lowerInput" class="form-label">Undre gräns</label>
                                <input id="lowerInput" type="number" class="form-control" v-model="data.settings.lower" />
                            </div>
                            <div class="col-4">
                                <label for="upperInput" class="form-label">Övre gräns</label>
                                <input id="upperInput" type="number" class="form-control" v-model="data.settings.upper" />
                            </div>
                        </div>
                        <div v-else>
                            <div class="row">
                                <div class="col-2"></div>
                                <div class="col-2">undre</div>
                                <div class="col-2">övre</div>
                                <div class="col-2"></div>
                                <div class="col-2">undre</div>
                                <div class="col-2">övre</div>
                            </div>
                            <div v-for="m in 6" class="row">
                                <div class="col-2">{{ months[m - 1] }}</div>
                                <div class="col-2">
                                    <input type="number" class="form-control" v-model="data.settings.months[m - 1].lower" />
                                </div>
                                <div class="col-2">
                                    <input type="number" class="form-control" v-model="data.settings.months[m - 1].upper" />
                                </div>
                                <div class="col-2">{{ months[m + 5] }}</div>
                                <div class="col-2">
                                    <input type="number" class="form-control" v-model="data.settings.months[m + 5].lower" />
                                </div>
                                <div class="col-2">
                                    <input type="number" class="form-control" v-model="data.settings.months[m + 5].upper" />
                                </div>
                            </div>
                        </div>
                        <div class="text-danger" v-show="data.errors.limits">{{ data.errors.limits }}</div>
                    </div>
                    <div class="mb-3 row" v-show="data.checkType === 'collection'">
                        <div class="row mt-3">
                            <div class="col-6">
                                <label for="limitSelect" class="form-label">Kontroll</label>
                                <select id="limitSelect" class="form-select" v-model="data.settings.limitType">
                                    <option value="count">Saknade överstiger antal</option>
                                    <option value="percent">Inkommande understiger andel (%)</option>
                                </select>
                                <div class="text-danger" v-show="data.errors.limitType">{{ data.errors.limitType }}</div>
                            </div>
                            <div class="col-2">
                                <label for="limitInput" class="form-label">{{ data.settings.limitType ? (String(data.settings.limitType).endsWith('percent') ? '%' : 'Antal') : '\u00a0' }}</label>
                                <input id="limitInput" type="number" min="0" class="form-control" v-model="data.settings.limitValue" />
                                <div class="text-danger" v-show="data.errors.limitValue">{{ data.errors.limitValue }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3 row" v-show="data.checkType === 'status'">
                        <div class="col-6">
                            <label for="flagFieldInput" class="form-label">Flaggfält
                                <info-icon title="Ett heltal som representerar flaggan eller flaggorna." />
                            </label>
                            <input id="flagFieldInput" type="text" class="form-control" v-model="data.settings.flags" />
                            <div class="text-danger" v-show="data.errors.flags">{{ data.errors.flags }}</div>
                        </div>
                        <div class="col-6">
                            <label for="flagNameInput" class="form-label">Namn
                                <info-icon title="Ange vad flaggfältet representerar, detta blir namnet på själva larmet. T.ex.: Läckage." />
                            </label>
                            <input id="flagNameInput" type="text" class="form-control" v-model="data.settings.flagsName" />
                            <div class="text-danger" v-show="data.errors.flagsName">{{ data.errors.flagsName }}</div>
                        </div>
                    </div>
                    <!-- Selection -->
                    <div class="mt-3 mb-3" v-show="props.data.settings.mpType && props.data.settings.mpType !== 'all' && !props.data.settings.mpType.includes('|')">
                        <input type="radio" id="allApartmentsRadio" class="form-check-input" v-model="data.settings.allApartments" value="true" name="all-apartments" />
                        <label for="allApartmentsRadio" class="form-label">&nbsp;Alla mätplatser</label>
                        <input type="radio" id="someApartmentsRadio" class="ms-3 form-check-input" v-model="data.settings.allApartments" value="false" name="all-apartments" />
                        <label for="someApartmentsRadio" class="form-label">&nbsp;Valda mätplatser</label>
                    </div>
                    <div class="mb-3 row" v-show="props.data.settings.mpType && props.data.settings.mpType !== 'all' && !props.data.settings.mpType.includes('|') && data.settings.allApartments === 'false'">
                        <div class="col-6 ms-3" style="border:1px solid #ced4da; border-radius: .375rem; width:300px; height: 200px; overflow-y: scroll;">
                            <div v-for="a in props.apartments" class="ms-1">
                                <input :id="`apartment${a.id}Check`" type="checkbox" v-model="data.settings.apartmentsSelected[a.id]" />
                                <label :for="`apartment${a.id}Check`">&nbsp;{{ a.number + (a.address ? ` (${a.address})` : '') }}</label>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="mt-3">
                                {{ Object.keys(data.settings.apartmentsSelected).filter(k => data.settings.apartmentsSelected[k]).length }} av {{ props.apartments.length }} valda
                            </div>
                            <div class="mt-3">
                                <button class="btn btn-secondary btn-sm" @click="selectAllApartments">Markera alla</button>
                            </div>
                            <div class="mt-3">
                                <button class="btn btn-secondary btn-sm" @click="deselectAllApartments">Avmarkera alla</button>
                            </div>
                        </div>
                        <div class="text-danger" v-show="data.errors.apartments">{{ data.errors.apartments }}</div>
                    </div>
                    <div v-if="data.checkType === 'usage' || data.checkType === 'average' || data.checkType === 'collection' ">
                        <div class="row mb-3">
                            <label for="intervalCountInput" class="form-label">Fördröjning
                                <info-icon title="Hur länge det skall dröja, efter avslutat kalenderintervall, innan kontrollen utförs. Detta är för att alla enheter skall hinna rapportera in data." />
                            </label>
                            <div class="col-2">
                                <input id="delayCountInput" type="number" min="1" class="form-control" v-model="data.delayCount" :disabled="data.noDelay" />
                                <div class="text-danger" v-show="data.errors.delayCount">{{ data.errors.delayCount }}</div>
                            </div>
                            <div class="col-3">
                                <select id="delayTypeSelect" class="form-select" v-model="data.delayType" :disabled="data.noDelay">
                                    <option value="minutes">{{ data.delayCount == 1 ? 'minut' : 'minuter' }}</option>
                                    <option v-show="data.intervalType != 'hour'" value="hour">{{ data.delayCount == 1 ? 'timme' : 'timmar' }}</option>
                                    <option v-show="data.intervalType != 'hour' && data.intervalType != 'day'" value="day">{{ data.delayCount == 1 ? 'dag' : 'dagar' }}</option>
                                    <option v-show="data.intervalType === 'year'" value="month">{{ data.delayCount == 1 ? 'månad' : 'månader' }}</option>
                                </select>
                                <div class="text-danger" v-show="data.errors.delayType">{{ data.errors.delayType }}</div>
                            </div>
                            <div class="col-3">
                                <input type="checkbox" id="noDelayCheckBox" class="form-check-input" v-model="data.noDelay" @change="onNoDelayCheckChanged" />
                                <label for="noDelayCheckBox" class="form-check-label">&nbsp;Ingen fördröjning</label>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <label for="emailInput" class="form-label">E-postadresser
                            <info-icon title="En kommaseparerad lista med e-postadresser." />
                        </label>
                        <div class="col-9">
                            <input id="emailInput" type="text" class="form-control" v-model="data.settings.email" />
                            <div class="text-danger" v-show="data.errors.email">{{ data.errors.email }}</div>
                        </div>
                        <div class="col-3">
                            <input type="checkbox" id="sendInstantlyCheckBox" class="form-check-input" v-model="data.settings.sendInstantly" />
                            <label for="sendInstantlyCheckBox" class="form-check-label">&nbsp;Skicka direkt
                                <info-icon title="Larma så fort felet upptäcks, annars skickas alla larm till varje enskild e-postadress samlat i ett e-mejl kl. 06:00. OBS! Endast ett begränsat antal larm skickas till en e-post adress per dag, så bocka inte för denna utan att det är viktigt." />
                            </label>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="$emit('close')">Avbryt</button>
                        <button type="button" class="btn btn-primary" @click="onSave">Spara</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import InfoIcon from '@/components/InfoIcon.vue'
import alarmsService from '@/services/alarmsService'
import seriesHelpers from '@/helpers/seriesHelpers'

const currentTab = ref('type')
const emit = defineEmits([ 'close', 'reload' ])

const months = [
    'januari', 'februari', 'mars', 'april', 'maj', 'juni',
    'juli', 'augusti', 'september', 'oktober', 'november', 'december'
]

const props = defineProps({
    data: Object,
    apartments: Array,
})

function onNoDelayCheckChanged() {
    if (props.data.noDelay) {
        props.data.delayCount = null
        props.data.delayType = null
        props.data.errors.delayCount = null
        props.data.errors.delayType = null
    }
}

function selectAllApartments() {
    props.data.settings.apartmentsSelected = {}
    props.apartments.forEach(a => props.data.settings.apartmentsSelected[a.id] = true)
}

function deselectAllApartments() {
    props.data.settings.apartmentsSelected = {}
}

function updateDeviceTypes(clear = false) {
    props.data.form.mpSelection = [ ]
    if (props.data.checkType === 'collection') {
        props.data.form.mpSelection.push({ value: 'all', label: 'Alla' })
    }
    for (const mpType of props.data.form.mpTypes) {
        switch (props.data.checkType) {
            case 'usage':
                switch (mpType) {
                    case 'cold_water':
                    case 'hot_water':
                    case 'electricity':
                    case 'heat':
                    case 'cold':
                    case 'hca':
                        props.data.form.mpSelection.push({ value: mpType, label: seriesHelpers.getMeasurementLabel(mpType) })
                        break
                }
                break
            case 'average':
            case 'value':
                switch (mpType) {
                    case 'heat':
                    case 'cold':
                    case 'ambiance':
                        props.data.form.mpSelection.push({ value: mpType, label: seriesHelpers.getMeasurementLabel(mpType) })
                        break
                }
                break
            case 'status':
            case 'collection':
                props.data.form.mpSelection.push({ value: mpType, label: seriesHelpers.getMeasurementLabel(mpType) })
                break
        }
    }
    for (const mp of props.data.form.mps) {
        switch (props.data.checkType) {
            case 'usage':
                switch (mp.measurement) {
                    case 'cold_water':
                    case 'hot_water':
                    case 'electricity':
                    case 'heat':
                    case 'cold':
                    case 'hca':
                        props.data.form.mpSelection.push({ value: mp.id + '|' + mp.measurement, label: mp.idNumber + ' (' + seriesHelpers.getMeasurementLabel(mp.measurement) + (mp.place ? ', ' + mp.place : '') + ')' })
                        break
                }
                break
            case 'average':
            case 'value':
                switch (mp.measurement) {
                    case 'heat':
                    case 'cold':
                    case 'ambiance':
                    props.data.form.mpSelection.push({ value: mp.id + '|' + mp.measurement, label: mp.idNumber + ' (' + seriesHelpers.getMeasurementLabel(mp.measurement) + (mp.place ? ', ' + mp.place : '') + ')' })
                    break
                }
                break
            case 'status':
                props.data.form.mpSelection.push({ value: mp.id + '|' + mp.measurement, label: mp.idNumber + ' (' + seriesHelpers.getMeasurementLabel(mp.measurement) + (mp.place ? ', ' + mp.place : '') + ')' })
                break
        }
    }
    if (clear) {
        props.data.settings.mpType = null
    }
    updateFields(clear)
}

defineExpose({ updateDeviceTypes })

function updateFields(clear = false) {
    if (clear) {
        props.data.settings.field = null
    }
    props.data.form.fields = []

    if (!props.data.settings.mpType || props.data.settings.mpType === 'all') {
        return
    }

    let mpType = props.data.settings.mpType
    if (mpType.includes('|')) {
        mpType = mpType.split('|')[1]
    }

    switch (props.data.checkType) {
        case 'usage':
            switch (mpType) {
                case 'cold_water':
                case 'hot_water':
                    props.data.form.fields = ['volume', 'volume-back']
                    break
                case 'electricity':
                    props.data.form.fields = ['energy']
                    break
                case 'heat':
                case 'cold':
                    props.data.form.fields = ['energy', 'volume', 'calculated-diff-temp']
                    break
                case 'hca':
                    props.data.form.fields = ['count']
                    break
            }
            break
        case 'average':
        case 'value':
            switch (mpType) {
                case 'heat':
                case 'cold':
                    props.data.form.fields = ['power', 'volume-flow', 'flow-temp', 'return-temp', 'diff-temp']
                    break
                case 'ambiance':
                    props.data.form.fields = ['ext-temp', 'relative-humidity']
                    break
            }
            break
        case 'status':
            props.data.form.fields = ['status', 'error']
            break
    }
    if (props.data.form.fields.length === 1) {
        props.data.settings.field = props.data.form.fields[0]
    }
}

function validate() {
    let valid = true

    // Set all errors to null
    for (const key in props.data.errors) {
        props.data.errors[key] = null
    }

    const settings = {}

    if (!props.data.checkType) {
        props.data.errors.checkType = 'Välj ett alternativ'
        valid = false
    }

    if (!props.data.settings.mpType) {
        props.data.errors.mpType = 'Välj ett alternativ'
        valid = false
    }
    settings.mpType = props.data.settings.mpType

    if (props.data.checkType != 'collection' && !props.data.settings.field) {
        props.data.errors.field = 'Välj ett alternativ'
        valid = false
    }
    settings.field = props.data.settings.field

    if (props.data.checkType === 'usage' ||
        props.data.checkType === 'average' ||
        props.data.checkType === 'collection'
    ) {
        if (!props.data.intervalType) {
            props.data.errors.intervalType = 'Välj ett alternativ'
            valid = false
        }
    }

    if (props.data.checkType === 'collection') {
        if (!props.data.intervalCount) {
            props.data.errors.intervalCount = 'Välj antal intervall'
            valid = false
        }
        
        if (!props.data.settings.limitType) {
            props.data.errors.limitType = 'Välj ett alternativ'
            valid = false
        }
        settings.limitType = props.data.settings.limitType

        if (props.data.settings.limitValue == null) {
            props.data.errors.limitValue = 'Ange värde'
            valid = false
        } else {
            if (props.data.settings.limitType === 'percent') {
                if (props.data.settings.limitValue < 1 || props.data.settings.limitValue > 100) {
                    props.data.errors.limitValue = 'Måste vara mellan 1 och 100'
                    valid = false
                }
            } else {
                if (props.data.settings.limitValue < 0) {
                    props.data.errors.limitValue = 'Måste vara större än 0'
                    valid = false
                }
            }
        }
        settings.limitValue = props.data.settings.limitValue
    }

    if (props.data.checkType === 'usage' ||
        props.data.checkType === 'average' ||
        props.data.checkType === 'value'
    ) {
        if (props.data.settings.sameAllMonths === 'false') {
            let empty = true
            for (let i = 0; i < 12; i++) {
                if (props.data.settings.months[i].lower != null || props.data.settings.months[i].upper != null) {
                    empty = false
                    break
                }
            }
            if (empty) {
                props.data.errors.limits = 'Ange minst ett gränsvärde'
                valid = false
            }
            settings.months = props.data.settings.months
        } else {
            if (isNullOrEmpty(props.data.settings.lower) && isNullOrEmpty(props.data.settings.upper)) {
                props.data.errors.limits = 'Ange minst ett gränsvärde'
                valid = false
            }
            settings.lower = valueOrNullIfEmpty(props.data.settings.lower)
            settings.upper = valueOrNullIfEmpty(props.data.settings.upper)
        }
    }

    if (props.data.checkType === 'status') {
        if (props.data.settings.flags == null || !/^\d+$/.test(props.data.settings.flags)) {
            props.data.errors.flags = 'Ange ett heltal'
            valid = false
        }
        settings.flags = Number(props.data.settings.flags)
        if (props.data.settings.flagsName == null || props.data.settings.flagsName.trim() === '') {
            props.data.errors.flagsName = 'Ange ett namn på larmet'
            valid = false
        }
        settings.flagsName = props.data.settings.flagsName
    }

    if (props.data.settings.allApartments === 'false') {
        if (Object.keys(props.data.settings.apartmentsSelected).filter(k => props.data.settings.apartmentsSelected[k]).length === 0) {
            props.data.errors.apartments = 'Välj minst en mätplats'
            valid = false
        }

        settings.apartments = []
        for (const key in props.data.settings.apartmentsSelected) {
            if (props.data.settings.apartmentsSelected[key]) {
                settings.apartments.push(parseInt(key))
            }
        }
    } else {
        settings.apartments = null
    }

    if ((props.data.checkType === 'collection' || props.data.checkType === 'usage' || props.data.checkType === 'average') &&
        !props.data.noDelay
    ) {
        if (!props.data.delayCount) {
            props.data.errors.delayCount = 'Ange antal'
            valid = false
        }
        if (!props.data.delayType) {
            props.data.errors.delayType = 'Välj ett alternativ'
            valid = false
        }
    }

    // Simple email validation
    let addresses
    if (props.data.settings.email) {
        addresses = props.data.settings.email.split(',')
    } else {
        addresses = []
    }
    const re = /\S+@\S+\.\S+/
    for (const address of addresses) {
        if (!re.test(address.trim())) {
            props.data.errors.email = '"' + address + '" är en ogiltig e-postadress.'
            valid = false
            break
        }
    }
    settings.email = props.data.settings.email
    if (props.data.settings.sendInstantly) {
        settings.sendInstantly = true
    }

    console.log('Valid:', valid, 'Settings:', settings)

    return valid ? settings : null
}

function goToTab(tab) {
    const oldTab = document.getElementById(currentTab.value + 'TabButton')
    oldTab.classList.remove('active')
    const newTab = document.getElementById(tab + 'TabButton')
    newTab.classList.add('active')
    currentTab.value = tab
}

function isNullOrEmpty(value) {
    return value == null || new String(value).trim() === ''
}

function valueOrNullIfEmpty(value) {
    return isNullOrEmpty(value) ? null : value
}

async function onSave() {
    const settings = validate()
    if (!settings) {
        return
    }

    const data = { 
        checkType: props.data.checkType,
        intervalType: props.data.intervalType,
        intervalCount: props.data.intervalCount,
        delayType: props.data.delayType,
        delayCount: props.data.delayCount,
        settings,
        isEnabled: props.data.isEnabled,
    }

    if (props.data.alarmCheckId) {
        await alarmsService.updateAlarmCheck(props.data.alarmCheckId, data)
    } else {
        await alarmsService.createAlarmCheck(props.data.siteId, data)
    }
    emit('reload')
    emit('close')
}
</script>